import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemRoyalMirror extends Item {
    constructor() {
        super(definitions.ITEM_ID.ROYAL_SVAN_MIRROR, texture("prop_royal_swan_mirror"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}